/** @format */

import { api } from "../app/services/api";

export const AUTH_COOKIE_KEY = "auth";
export const AUTH_COOKIE_INVALID_VALUE = "invalid"; // value used by api to invalidated cookie

export const authApiSlice = api.injectEndpoints({
  endpoints: (build) => ({
    bbLogin: build.query({
      query: (code) =>
        `bblogin?code=${code}&clientId=${process.env.REACT_APP_BB_AUTH_CLIENT_ID}`,
    }),
    hwbLogin: build.query({
      query: ({ code, origin }) => `hwblogin?code=${code}&origin=${origin}`,
    }),
    logout: build.query({ query: () => "logout" }),
  }),
});

export const { useBbLoginQuery, useHwbLoginQuery, useLogoutQuery } =
  authApiSlice;
